import { render, staticRenderFns } from "./ProductDescriptionItem.vue?vue&type=template&id=022b4dac&scoped=true"
import script from "./ProductDescriptionItem.vue?vue&type=script&lang=js"
export * from "./ProductDescriptionItem.vue?vue&type=script&lang=js"
import style0 from "./ProductDescriptionItem.vue?vue&type=style&index=0&id=022b4dac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022b4dac",
  null
  
)

export default component.exports